// Strings of General accounts › Legacy history: the documents the migration kept as stored, read only. Arabic marked
// "new" needs review by an Arabic copy editor.
export const LEGACY_HISTORY_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    legacyHistory: "Legacy history",
    lhSub: "{n} imported documents · read only",
    lhNote: "Imported from the legacy system as stored. These are history, not Delta invoices or vouchers: they are never posted, edited or recalculated here, and they are not in Delta's sales, purchase, VAT or stock figures. Their accounting effect is the migrated journal entries linked to each one, already in the ledger. New invoices are under Sales and Purchases.",
    lhBadge: "Legacy · read only",
    lhSearch: "Number, customer or supplier, reference, note",
    lhType: "Document type",
    lhAllTypes: "All types",
    lhAllBranches: "All branches",
    lhNumber: "Legacy number",
    lhDate: "Legacy date",
    lhParty: "Customer / supplier",
    lhStoredAmounts: "Stored amounts",
    lhEntries: "Ledger entries",
    lhLines: "Lines",
    lhNone: "No legacy history",
    lhNoneBody: "This business holds no documents imported from the legacy system.",
    lhNoMatch: "No legacy documents match",
    lhNoMatchBody: "Change the search or the filters.",
    lhHidden: "{n} more legacy documents are outside your branch, warehouse or treasury scope.",
    lhShowing: "{a}–{b} of {n}",
    lhDocTitle: "Legacy {type} {x}",
    lhDetails: "Document",
    lhOriginal: "Original record, as stored",
    lhOriginalHint: "Every field of the legacy row exactly as extracted. Amounts keep their stored decimals.",
    lhField: "Field",
    lhValue: "Value",
    lhLinesTitle: "Lines, as stored",
    lhItem: "Item in Delta",
    lhEntriesTitle: "Migrated journal entries",
    lhEntriesHint: "The legacy entries that belong to this document, as migrated. Open one to see its lines.",
    lhNoEntries: "No journal entry names this document in the legacy data.",
    lhLinks: "Settlements and refunds, as stored",
    lhLinkSettlement: "Settlement",
    lhLinkRefund: "Refund of",
    lhLinkRefundedBy: "Refunded by",
    lhLinkSettles: "Settles",
    lhLinkSettledBy: "Settled by",
    lhOutOfScope: "outside your scope",
    lhLegacyId: "Legacy id",
    lhRefs: "In Delta",
    lhNotFound: "This legacy document was not found, or it is outside your scope.",
    lhBack: "Back to legacy history",
    lhToWarehouse: "To warehouse",
    lhToTreasury: "To treasury",
    lhSecondAccount: "Second account",
    tbShared: "shared account · {n} treasuries",
    tbSharedHint: "This treasury's account is linked to {n} treasuries. The row shows only the ledger lines whose legacy record names this treasury.",
    tbRemainder: "Shared account, not attributable to one treasury",
    tbRemainderSub: "linked to {n} treasuries",
    tbSharedNote: "{n} account(s) are linked to more than one treasury. Each such treasury shows only the migrated lines whose legacy record names it; the rest of the account's balance is shown once, on its own row, and is not divided between them. Each account's balance is counted once in the totals."
  },
  ar: {
    legacyHistory: "سجل النظام السابق", // new
    lhSub: "{n} مستند مستورد · للعرض فقط", // new
    lhNote: "مستورد من النظام السابق كما هو مخزّن. هذه سجلات تاريخية وليست فواتير أو سندات في دلتا: لا تُرحَّل ولا تُعدَّل ولا يُعاد حسابها هنا، ولا تدخل في أرقام المبيعات أو المشتريات أو الضريبة أو المخزون في دلتا. أثرها المحاسبي هو قيود اليومية المُرحَّلة المرتبطة بكل مستند، وهي موجودة في الدفاتر. الفواتير الجديدة في المبيعات والمشتريات.", // new
    lhBadge: "النظام السابق · للعرض فقط", // new
    lhSearch: "الرقم أو العميل أو المورد أو المرجع أو الملاحظة", // new
    lhType: "نوع المستند", // new
    lhAllTypes: "كل الأنواع", // new
    lhAllBranches: "كل الفروع", // new
    lhNumber: "الرقم في النظام السابق", // new
    lhDate: "التاريخ في النظام السابق", // new
    lhParty: "العميل / المورد", // new
    lhStoredAmounts: "المبالغ المخزّنة", // new
    lhEntries: "قيود اليومية", // new
    lhLines: "البنود", // new
    lhNone: "لا يوجد سجل من النظام السابق", // new
    lhNoneBody: "لا توجد لهذه المنشأة مستندات مستوردة من النظام السابق.", // new
    lhNoMatch: "لا توجد مستندات مطابقة", // new
    lhNoMatchBody: "غيّر البحث أو عوامل التصفية.", // new
    lhHidden: "{n} مستند آخر من النظام السابق خارج نطاق فرعك أو مستودعاتك أو خزائنك.", // new
    lhShowing: "{a}–{b} من {n}", // new
    lhDocTitle: "{type} من النظام السابق {x}", // new
    lhDetails: "المستند", // new
    lhOriginal: "السجل الأصلي كما هو مخزّن", // new
    lhOriginalHint: "كل حقول السجل في النظام السابق كما استُخرجت تمامًا. المبالغ بخاناتها العشرية المخزّنة.", // new
    lhField: "الحقل", // new
    lhValue: "القيمة", // new
    lhLinesTitle: "البنود كما هي مخزّنة", // new
    lhItem: "الصنف في دلتا", // new
    lhEntriesTitle: "قيود اليومية المُرحَّلة", // new
    lhEntriesHint: "قيود النظام السابق التابعة لهذا المستند كما رُحّلت. افتح أيًّا منها لترى أسطره.", // new
    lhNoEntries: "لا يوجد قيد يشير إلى هذا المستند في بيانات النظام السابق.", // new
    lhLinks: "التسويات والمرتجعات كما هي مخزّنة", // new
    lhLinkSettlement: "تسوية", // new
    lhLinkRefund: "مرتجع من", // new
    lhLinkRefundedBy: "مرتجعه", // new
    lhLinkSettles: "يسدّد", // new
    lhLinkSettledBy: "سُدّد بـ", // new
    lhOutOfScope: "خارج نطاقك", // new
    lhLegacyId: "المعرّف في النظام السابق", // new
    lhRefs: "في دلتا", // new
    lhNotFound: "لم يُعثر على هذا المستند، أو هو خارج نطاقك.", // new
    lhBack: "العودة إلى سجل النظام السابق", // new
    lhToWarehouse: "إلى المستودع", // new
    lhToTreasury: "إلى الخزينة", // new
    lhSecondAccount: "الحساب الثاني", // new
    tbShared: "حساب مشترك · {n} خزائن", // new
    tbSharedHint: "حساب هذه الخزينة مرتبط بـ {n} خزائن. يعرض السطر قيود الدفتر التي يذكر سجلها في النظام السابق هذه الخزينة فقط.", // new
    tbRemainder: "حساب مشترك لا يُنسب إلى خزينة واحدة", // new
    tbRemainderSub: "مرتبط بـ {n} خزائن", // new
    tbSharedNote: "{n} حساب مرتبط بأكثر من خزينة. تعرض كل خزينة منها قيود الترحيل التي يذكرها سجلها في النظام السابق فقط، ويظهر باقي رصيد الحساب مرة واحدة في سطر مستقل دون تقسيمه بينها. يُحتسب رصيد كل حساب مرة واحدة في الإجماليات." // new
  }
};
